<div class="acs-page">
  <div class="no-access-container">
    <div class="no-access-content">
      <div class="no-access-icon">
        <svg width="80" height="80" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#dc3545" stroke-width="2"/>
          <path d="M15 9l-6 6M9 9l6 6" stroke="#dc3545" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>

      <h1 class="no-access-title">Access Denied</h1>

      <!-- Message for "No Access" role from API -->
      <p class="no-access-message" *ngIf="isNoAccessRole">
        For assistance with login, please contact Ashley Claire, at
        <a href="tel:312-202-5737" class="no-access-link">312-202-5737</a> or
        <a href="mailto:aclaire@facs.org" class="no-access-link">aclaire&#64;facs.org</a>
      </p>

      <!-- Message for route permission denied -->
      <p class="no-access-message" *ngIf="!isNoAccessRole">
        You don't have permission to access this page. Please contact your system administrator if you believe this is an error.
      </p>

      <div class="no-access-actions">
        <!-- Only logout button for "No Access" role -->
        <div *ngIf="isNoAccessRole">
          <acs-button
            variant="secondary"
            (clicked)="logout()">
            Logout
          </acs-button>
        </div>

        <!-- Dashboard and logout buttons for route permission denied -->
        <div *ngIf="!isNoAccessRole" class="no-access-buttons">
          <acs-button
            variant="primary"
            (clicked)="goToDashboard()">
            Go to Dashboard
          </acs-button>

          <acs-button
            variant="secondary"
            (clicked)="logout()">
            Logout
          </acs-button>
        </div>
      </div>
    </div>
  </div>
</div>